import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import MyOrderItem from "../Shopping/MyOrderItem"
import DaumPostcodeEmbed from 'react-daum-postcode';
import AddressSelectPopup from "../../../components/Popup/AddressSelectPopup";
import orderApi from "../../../services/Order/orderApi";
import instance from "../../../services/services";
import { MY_PAGE_ORDER_EXCHANGE_RETURN_LIST_URL, MY_PAGE_ORDER_EXCHANGE_RETURN_URL, MY_PAGE_ORDER_EXCHANGE_RETURN_UPDATE_URL } from "../../../utils/urls";
import PopupLoginError from "../../../components/Popup/LoginError";
import { formatLocalString } from "../../../utils/validation";
import { useLanguage } from "../../../hooks/useLanguage";


function OrderReturnForm(){
  const location = useLocation();
  const { t } = useLanguage();
  const selectRef = useRef();
  const [selectedDelivery, setSelectedDelivery] = useState('default'); // 배송지 선택
  const [isAgreed, setIsAgreed] = useState(false);
  const [itemData, setItemData] = useState([]);
  const [serialData, setSerialData] = useState({}); // 시리얼 데이터
  const [selectedReturnMethod, setSelectedReturnMethod] = useState('shop'); // 디폴트 회수신청 - 위치 변경
  const [popupLoginError, setPopupLoginError] = useState(false);
  const [orderInfo, setOrderInfo] = useState({});
  const [returnInfoData, setReturnInfoData] = useState({});
  // 우편번호 관련 상태 추가
  const [isPostcodeOpen, setIsPostcodeOpen] = useState(false);
  const [deliveryAddress, setDeliveryAddress] = useState({
    zonecode: '',
    roadAddress: '',
    detailAddress: ''
  });
  
  // 주소록 팝업 상태 추가
  const [isPopupAddr, setPopupAddr] = useState(false);
  const [deliveryData, setDeliveryData] = useState({});
  
  // 받는 사람 정보 상태 추가
  const [recipientInfo, setRecipientInfo] = useState({
    name: '',
    phone: ''
  });
  
  // 선택된 시리얼 번호 관리를 위한 상태 추가
  const [selectedSerials, setSelectedSerials] = useState([]);

  // 초기 로드 여부를 확인하기 위한 ref 추가
  const initialLoadRef = useRef(true);

  // 사용자가 수동으로 선택한 시리얼 추적을 위한 ref 추가
  const userSelectedSerialsRef = useRef([]);
  
  // 초기화 ref 뒤에 추가할 변수 (라인 ~48 근처)
  const prevParamsRef = useRef({
    returnMethod: 'shop',
    returnReason: '',
    serialSeqs: []
  });
  
  // 주소록 보기 핸들러
  const handleAddrSelectPopup = () => {
    setPopupAddr(true);
  };
  
  // 주소 선택 완료 핸들러
  const handleAddressConfirm = (selectedAddress) => {
    if (selectedAddress) {
      // 기본 주소로 설정
      setSelectedDelivery('default');
      
      // deliveryData 상태 업데이트
      setDeliveryData({
        ...deliveryData,
        recipient_name: selectedAddress.recipient_name,
        recipient_phone: selectedAddress.recipient_phone,
        recipient_zipcode: selectedAddress.recipient_zipcode,
        recipient_address_street: selectedAddress.recipient_address_street,
        recipient_address_detail: selectedAddress.recipient_address_detail
      });

      // 배송 주소 상태 업데이트
      setDeliveryAddress({
        zonecode: selectedAddress.recipient_zipcode,
        roadAddress: selectedAddress.recipient_address_street,
        detailAddress: selectedAddress.recipient_address_detail
      });

      // 받는 사람 정보 업데이트
      setRecipientInfo({
        name: selectedAddress.recipient_name,
        phone: selectedAddress.recipient_phone
      });
    }
  };
  
  // 우편번호 찾기 핸들러
  const handlePostcodeOpen = () => {
    setIsPostcodeOpen(true);
  };
  
  // 우편번호 선택 완료 핸들러
  const handlePostcodeComplete = (data) => {
    setDeliveryAddress({
      zonecode: data.zonecode,
      roadAddress: data.roadAddress,
      detailAddress: ''
    });
    setIsPostcodeOpen(false);
  };
  
  // 우편번호 팝업 닫기 핸들러
  const handlePostcodeClose = () => {
    setIsPostcodeOpen(false);
  };
  
  // 상세 주소 변경 핸들러
  const handleDetailAddressChange = (e) => {
    setDeliveryAddress(prev => ({
      ...prev,
      detailAddress: e.target.value
    }));
  };

  const selectList = [
    { value: '1', name: '단순 변심' },
    { value: '2', name: '선택 오류' },
    { value: '3', name: '상품 불량' },
    { value: '4', name: '오배송' },
    { value: '5', name: '상품 상이' },
    { value: '6', name: '기타' }
  ];
  
  const [state, setState] = useState({
    isReason: false,
    isImageRequired: false // 초기값을 false로 변경
  });

  const [formData, setFormData] = useState({
    return_memo: '',
    upload_images: []
  });
  const handleSelectOpen = () => {
    setState(prev => ({ ...prev, isReason: !prev.isReason }));
  };

  const handleSelectedItem = (select) => {
    // 오배송, 상품상이, 상품불량인 경우 이미지 필요
    const needsImage = ['3', '4', '5'].includes(select.value);
    
    setState(prev => ({
      ...prev,
      isReason: false,
      selectValue: select.value,
      selectedName: select.name, // 선택된 이름 저장
      isImageRequired: needsImage // 이미지 필요 여부 업데이트
    }));
  };
  
  // 외부 클릭시, 셀렉박스 닫힘
  useEffect(() => {
    function handleClickOutside(event) {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setState(prev => ({ ...prev, isReason: false }));
      }
    }
  
    document.addEventListener("mousedown", handleClickOutside);
  
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // 배송지 선택 
  const handleDeliveryChange = (e) => {
    const newValue = e.target.value;
    setSelectedDelivery(newValue);
    
    if (newValue === 'new') {
      // 새로 입력 선택 시 모든 필드 초기화
      setDeliveryAddress({
        zonecode: '',
        roadAddress: '',
        detailAddress: ''
      });
      
      // 받는 사람 정보도 초기화
      setRecipientInfo({
        name: '',
        phone: ''
      });
    } else {
      // 기본 주소 선택 시 정보 복원
      setDeliveryAddress({
        zonecode: deliveryData.recipient_zipcode || '',
        roadAddress: deliveryData.recipient_address_street || '',
        detailAddress: deliveryData.recipient_address_detail || ''
      });
      
      // 받는 사람 정보도 복원
      setRecipientInfo({
        name: deliveryData.recipient_name || '',
        phone: deliveryData.recipient_phone || ''
      });
    }
  };

  // 배송지 정보
  const deliveryLIst = [
    {id:'default_addr', label:t('default_address'), value:'default'},
    {id:'new_addr', label:t('input_new_address'), value:'new'}
  ]

    // 배송지 목록
    useEffect(() => {
      const fetchDeliveryList = async () => {
        try {
          const response = await orderApi.getDefaultDeliveryInfo();
          setDeliveryData(response.data.data);
          
          // default_flag 값이 'Y'인 경우 기본주소 선택
          if (response.data.data.default_flag === 'Y') {
            setSelectedDelivery('default');
          } else {
            setSelectedDelivery('new');
          }
        } catch (error) {
          console.error('배송지 목록 조회 중 오류:', error);
          // 에러 발생 시 새로입력 선택
          setSelectedDelivery('new');
        }
      };
      fetchDeliveryList();
    }, []);

  // handleSerialChange 함수 수정 (라인 ~176 근처)
  const handleSerialChange = (serial_seq, isChecked) => {
    // serial_seq를 문자열로 변환
    const seqStr = String(serial_seq);
    
    // complete_flag가 'Y'인 시리얼은 선택 불가
    const serialItem = Object.values(serialData).find(item => String(item.serial_seq) === seqStr);
    if (serialItem && serialItem.complete_flag === 'Y') {
      return; // 이미 완료된 시리얼은 선택 변경 불가
    }
    
    // 새로운 선택 상태 생성
    const newSelectedSerials = isChecked 
      ? [...selectedSerials, seqStr]
      : selectedSerials.filter(seq => seq !== seqStr);
    
    // 상태 업데이트
    setSelectedSerials(newSelectedSerials);
    userSelectedSerialsRef.current = newSelectedSerials;
  };

  // 반품 신청 API 수정 (라인 ~304 근처)
  useEffect(() => {
    const handleExchange = async () => {
      if (!location.state) return;
      
      try {
        
        const response = await instance.post(MY_PAGE_ORDER_EXCHANGE_RETURN_LIST_URL, {
          order_seq: location.state.orderSeq,
          item_seq: location.state.itemSeq,
          return_type: "return"
        });

        // code가 -201이면 이전 페이지로 이동
        if (response.data.code === -201) {
          setPopupLoginError({
            message: response.data.message,
            action: 'navigate_login'
          });
          return;
        }
        
        setItemData(response.data.data.items);
        setSerialData(response.data.data.serial_data);
        setOrderInfo(response.data.data.orderInfo);
        
        // 시리얼 데이터가 1개인 경우 자동으로 선택
        if (response.data.data.serial_data && 
            Array.isArray(response.data.data.serial_data) && 
            response.data.data.serial_data.length === 1) {
          
          const singleSerial = String(response.data.data.serial_data[0].serial_seq);
          setSelectedSerials([singleSerial]);
          userSelectedSerialsRef.current = [singleSerial];
        } else if (response.data.data.serial_data && 
                  Object.values(response.data.data.serial_data).length === 1) {
          // serial_data가 배열이 아닌 객체인 경우 처리
          const serialValues = Object.values(response.data.data.serial_data);
          const singleSerial = String(serialValues[0].serial_seq);
          setSelectedSerials([singleSerial]);
          userSelectedSerialsRef.current = [singleSerial];
        } else {
          // 첫 로드 시 선택된 시리얼 값을 설정 (선택 플래그가 'Y'인 경우)
          const defaultSelected = Object.values(response.data.data.serial_data || {})
            .filter(data => data.selected_flag === "Y")
            .map(data => String(data.serial_seq));
          
          setSelectedSerials(defaultSelected);
          userSelectedSerialsRef.current = defaultSelected;
        }
        
        // 초기 로드 상태 변경
        initialLoadRef.current = false;
      }
      catch(error) {
        console.log(error,':::error');
      }
    };
    
    // 컴포넌트 마운트 시 한 번만 실행
    handleExchange();
    
  }, [location.state]);

  // 사용자 선택 변경 시 UPDATE API 호출 useEffect 추가 (handleExchange useEffect 다음에 추가)
  useEffect(() => {
    // 초기 로드 시에는 실행하지 않음
    if (initialLoadRef.current || !location.state) return;
    
    // 이전 값과 현재 값을 비교하여 변경이 있을 때만 API 호출
    const currentParams = {
      returnMethod: selectedReturnMethod,
      returnReason: state.selectValue || "",
      serialSeqs: selectedSerials
    };
    
    // 이전 값과 동일하면 API 호출 안 함
    if (JSON.stringify(prevParamsRef.current) === JSON.stringify(currentParams)) {
      return;
    }
    
    // 디바운스 타이머 설정
    const debounceTimer = setTimeout(async () => {
      try {
        
        const response = await instance.post(MY_PAGE_ORDER_EXCHANGE_RETURN_UPDATE_URL, {
          order_seq: location.state.orderSeq,
          item_seq: location.state.itemSeq,
          return_type: "return",
          return_method: selectedReturnMethod,
          return_reason: state.selectValue || "",
          "serial_seq": selectedSerials
        });

        // 응답 처리
        if (response.data.code === -201) {
          setPopupLoginError({
            message: response.data.message,
            action: 'navigate_login'
          });
          return;
        }
        
        // 환불금액
        setReturnInfoData(response.data.data.return_info);
        // 현재 파라미터를 이전 파라미터로 저장
        prevParamsRef.current = currentParams;
        
      } catch(error) {
        console.error("값 변경 API 오류:", error);
      }
    }, 300); // 300ms 디바운스
    
    // 클린업 함수에서 타이머 제거
    return () => clearTimeout(debounceTimer);
    
  }, [selectedReturnMethod, state.selectValue, selectedSerials, location.state]);

  const handleReturnMethodChange = (e) => {
    setSelectedReturnMethod(e.target.value);
  };
  
  // 반품 신청 제출 핸들러
  const handleReturnSubmit = async () => {
    if (!isAgreed) {
      setPopupLoginError(t('return_application_txt'));
      return;
    }
    
    if (!state.selectValue) {
      setPopupLoginError(t('return_reason_txt'));
      return;
    }
    
    let serialsToSubmit = [...selectedSerials];
    
    // 시리얼 번호가 없고, 시리얼 데이터가 1개인 경우 자동으로 선택
    if (serialsToSubmit.length === 0 && 
        serialData && 
        Object.values(serialData).length === 1) {
      
      const singleSerial = String(Object.values(serialData)[0].serial_seq);
      serialsToSubmit = [singleSerial];
      
      // 상태 업데이트 (UI에 반영)
      setSelectedSerials(serialsToSubmit);
      userSelectedSerialsRef.current = serialsToSubmit;
    }
    else if (serialsToSubmit.length === 0) {
      setPopupLoginError(t('return_serial'));
      return;
    }

    try {
      // 일반 객체 생성
      const requestData = {
        order_seq: location.state.orderSeq,
        item_seq: location.state.itemSeq,
        return_type: 'return',
        return_method: selectedReturnMethod,
        return_reason: state.selectValue,
        return_memo: formData.return_memo,
        // 시리얼 번호를 배열로 전송
        serial_seq: serialsToSubmit
      };
      
      // 회수신청일 경우에만 배송지 정보 추가
      if (selectedReturnMethod === 'shop') {
        // 배송지 정보 확인
        const senderName = selectedDelivery === 'default' 
          ? deliveryData.recipient_name || recipientInfo.name 
          : recipientInfo.name;
          
        const phoneNumber = selectedDelivery === 'default' 
          ? deliveryData.recipient_phone || recipientInfo.phone 
          : recipientInfo.phone;
          
        const zipCode = selectedDelivery === 'default' 
          ? deliveryData.recipient_zipcode || deliveryAddress.zonecode 
          : deliveryAddress.zonecode;
          
        const streetAddress = selectedDelivery === 'default' 
          ? deliveryData.recipient_address_street || deliveryAddress.roadAddress 
          : deliveryAddress.roadAddress;
          
        const detailAddress = selectedDelivery === 'default' 
          ? deliveryData.recipient_address_detail || deliveryAddress.detailAddress 
          : deliveryAddress.detailAddress;
        
        // 배송지 정보 추가
        requestData.sender_name = senderName;
        requestData.cellphone = phoneNumber;
        requestData.sender_zipcode = zipCode;
        requestData.sender_address_street = streetAddress;
        requestData.sender_address_detail = detailAddress;
      } else {
        // 직접반품인 경우 빈 문자열로 추가
        requestData.sender_name = '';
        requestData.cellphone = '';
        requestData.sender_zipcode = '';
        requestData.sender_address_street = '';
        requestData.sender_address_detail = '';
      }
      
      // 이미지가 있는 경우에만 FormData 사용
      if (formData.upload_images && formData.upload_images.length > 0) {
        const formDataObj = new FormData();
        
        // serial_seq 배열을 각각 append
        serialsToSubmit.forEach(serial => {
          formDataObj.append('serial_seq[]', serial);
        });
        
        // 이미지 파일들을 각각 append
        formData.upload_images.forEach(file => {
          formDataObj.append('upload_images[]', file);
        });
        
        // 나머지 requestData의 속성들 추가 (serial_seq 제외)
        Object.keys(requestData).forEach(key => {
          if (key !== 'serial_seq') {
            formDataObj.append(key, requestData[key]);
          }
        });
        
        // FormData로 API 호출
        const response = await instance.post(MY_PAGE_ORDER_EXCHANGE_RETURN_URL, formDataObj, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        
        handleApiResponse(response);
      } else {
        // 이미지가 없는 경우 일반 JSON 요청
        const response = await instance.post(MY_PAGE_ORDER_EXCHANGE_RETURN_URL, requestData);
        handleApiResponse(response);
      }
      
    } catch (error) {
      console.error('반품 신청 오류:', error);
      setPopupLoginError({
        message: error.response?.data?.message || '반품 신청 중 오류가 발생했습니다.'
      });
    }
    
    // API 응답 처리를 위한 내부 함수
    function handleApiResponse(response) {
      
      // code가 200일 때만 성공 처리
      if (response.data.code === 200) {
        setPopupLoginError({
          message: response.data.message || t('return_application_completed'),
          action: 'navigate_login'
        });
      } else {
        // 성공이 아닌 경우 에러 메시지 표시
        setPopupLoginError({
          message: response.data.message || '반품 신청 중 오류가 발생했습니다.'
        });
      }
    }
  };

  const handleConfirm = () => {
    // popupLoginError가 객체이고 action이 'navigate_login'인 경우에만 처리
    if (typeof popupLoginError === 'object' && popupLoginError.action === 'navigate_login') {
      setPopupLoginError(false);
      // 이전 페이지로 이동
      window.history.back();
    } else {
      // 단순히 팝업만 닫기
      setPopupLoginError(false);
    }
  }
  
  return(
    <div className="my_table mt_48">
      
      {/* 주문상품 정보 */}
      <div className="my_container order_detail_form">
        <h3 className="form_title">{t('return_application')}</h3>
        <div className="order_title">
          <h3>{t('order_product_info')}</h3> 
        </div>
          <MyOrderItem type="sale" orderList={itemData} orderType="exchange"/>
      </div>

      {/* 반품 정보 */}
      <div className="my_container order_detail_form return_form">
        <div className="order_title">
          <h3>{t('return_info_txt')}</h3>
        </div>
        <ul className="default_info_table v2">
          <li className="info_item">
            <div className="label">
              <span>{t('return_reason2')}</span>
            </div>
            <div className="form_info">
              <div className="info_detail default_input reason_select_con">
                {/* 반품사유 */}
                <div className="flex-8 column">
                  <div
                    ref={selectRef}
                    className={`default_select border ${state.isReason ? 'open' : ''}`}
                  >
                    <button
                      type="button"
                      className={`select_btn ${state.selectValue ? 'active' : ''}`}
                      onClick={handleSelectOpen}
                    >
                      <span className="ellipsis_clamp">
                        {state.selectedName || t('return_reason_selection')}
                      </span>
                    </button>
                    <ul className="select_list">
                      {selectList?.map(select => (
                        <li
                          key={select.value}
                          className={`select_item ellipsis1 ${
                            state.selectValue === select.value ? 'active' : ''
                          }`}
                          onClick={() => handleSelectedItem(select)}
                        >
                          {select?.name}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="default_input">
                    <textarea
                      value={formData.return_memo}
                      onChange={(e) =>
                        setFormData(prev => ({
                          ...prev,
                          return_memo: e.target.value
                        }))
                      }
                      placeholder={t('return_reason_input')}
                    />
                  </div>
                </div>
                {/* 반품시리얼 */}
                {Object.values(serialData).length > 1 && (
                  <div className="flex-8 column return_serial"> 
                    <p>{t('return_serial_selection_txt')}</p>
                    <div className="flex-12">
                      {serialData && Object.values(serialData).map((data, index) => {
                        // serial_seq를 문자열로 변환
                        const seqStr = String(data.serial_seq);
                        const isDisabled = data.complete_flag === 'Y';
                        
                        return (
                          <div className="default_chk_box" key={index}>
                            <input 
                              type="checkbox"
                              id={`serial_${seqStr}`}
                              checked={selectedSerials.includes(seqStr)}
                              onChange={(e) => handleSerialChange(seqStr, e.target.checked)}
                              disabled={isDisabled}
                            />
                            <label htmlFor={`serial_${seqStr}`} style={isDisabled ? {opacity: 0.5, cursor: 'not-allowed'} : {}}>
                              <span>{data.serial_number}</span>
                            </label>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
                {/* 이미지 첨부 */}
                {state.isImageRequired && (
                  <div className="attach_file">
                    <div className="img_attach_box">
                      {/* 이미지 첨부 버튼 - 이미지 5개 이상이면 숨김 */}
                      {formData.upload_images.length < 5 && (
                        <label
                          htmlFor="sub_img_attach"
                          className="default_btn ic_lg white attach_btn"
                        />
                      )}
                      <input
                        type="file"
                        className="i_hide"
                        id="sub_img_attach"
                        accept=".png,.jpg"
                        multiple
                        name="img_file"
                        onChange={(e) => {
                          const files = Array.from(e.target.files);
                          
                          // 최대 5개까지만 선택
                          const selectedFiles = [...formData.upload_images, ...files].slice(0, 5);
                          
                          // 이미지 파일 정보 저장
                          setFormData(prev => ({
                            ...prev,
                            upload_images: selectedFiles
                          }));
                        }}
                      />
                      <ul className="preview_list">
                        {formData.upload_images.map((file, index) => (
                          <li className="default_btn ic_lg" key={index}>
                            <img
                              className="object-cover"
                              src={URL.createObjectURL(file)}
                              alt={`첨부 이미지 ${index + 1}`}
                              loading="lazy"
                            />
                            <button
                              type="button"
                              className="delete_btn"
                              onClick={() => {
                                const newImages = [...formData.upload_images];
                                newImages.splice(index, 1);
                                setFormData(prev => ({
                                  ...prev,
                                  upload_images: newImages
                                }));
                              }}
                            />
                          </li>
                        ))}
                      </ul>
                    </div>
                    <p className="dash_list flex-2 column w-100">
                      <span>
                        {t('file_capacity_limit')}
                      </span>
                      <span>{t('maximum_5_images')} ({formData.upload_images.length}/5)</span>
                    </p>
                  </div>
                )}
                {/* 반품 배송비 정보 */}
                <div className="dash_list">
                  <div className="alert_box gray flex-2 column">
                    <span className="color_black">
                      {t('return_reason_1')}
                    </span>
                    <span className="color_black">
                      {t('return_reason_2_txt')}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li className="info_item addr_radio">
            <div className="label">
              <span>{t('return_method2')}</span>
            </div>
            <div className="form_info">
              <div className="info_detail">
                <div className="default_radio radio_list">
                  <div>
                    <input
                      type="radio"
                      name="return_method"
                      id="return_method_1"
                      value="shop"
                      onChange={handleReturnMethodChange}
                      checked={selectedReturnMethod === 'shop'}
                    />
                    <label htmlFor="return_method_1">{t('return_request')}</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      name="return_method"
                      id="return_method_2"
                      value="user"
                      onChange={handleReturnMethodChange}
                      checked={selectedReturnMethod === 'user'}
                    />
                    <label htmlFor="return_method_2">{t('direct_return3')}</label>
                  </div>
                <div>
              </div>
            </div>
          </div>
        </div>
        </li>
      </ul>
    </div>

      {/* 환불 정보 */}
      <div className="my_container order_detail_form">
        <div className="order_title">
          <h3>{t('refund_info')}</h3>
        </div>
        <ul className="default_info_table v2">
          <li className="info_item">
            <div className="label label_start">
              <span>{t('payment_amount')}</span>
            </div>
            <div className="form_info payment_info">
              <div className="info_detail flex-8 column">
                <p className="price">
                  {orderInfo.settleprice ? formatLocalString(orderInfo.settleprice) : "0"}
                  <i className="won xl">{t('price_txt')}</i>
                </p>
                <div className="text_small_b g-80 flex-4 column">
                  {orderInfo.total_rental_price > 0 && (
                    <div className="flex-center-4">
                      {t('product_amount2')}: {orderInfo.total_rental_price ? formatLocalString(orderInfo.total_rental_price) : "0"}{t('price_txt')}
                    </div>
                  )}
                  {orderInfo.shipping_cost > 0 && (
                    <div className="flex-center-4">
                      {t('delivery_fee')}: {orderInfo.shipping_cost ? formatLocalString(orderInfo.shipping_cost) : "0"}{t('price_txt')}
                    </div>
                  )}
                  {orderInfo.point > 0 && (
                    <div className="flex-center-4">
                      {t('point')}: {orderInfo.point ? formatLocalString(orderInfo.point) : "0"}{t('price_txt')}
                    </div>
                  )}
                  {orderInfo.total_sale_price > 0 && (
                    <div className="flex-center-4">
                      {t('discount')}: {orderInfo.total_sale_price ? formatLocalString(orderInfo.total_sale_price) : "0"}{t('price_txt')}
                    </div>
                  )}
                  {orderInfo.balance > 0 && (
                    <div className="flex-center-4">
                      {t('deposit_info_8')}: {orderInfo.balance ? formatLocalString(orderInfo.balance) : "0"}{t('price_txt')}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </li>
          <li className="info_item">
            <div className="label label_start">
              <span>{t('deduction_amount')}</span>
            </div>
            <div className="form_info payment_info">
              <div className="info_detail flex-8 column">
                <p className="price">
                  {returnInfoData?.total_delivery_cost ? formatLocalString(returnInfoData?.total_delivery_cost) : "0"}
                  <i className="won xl">{t('price_txt')}</i>
                </p>
                <div className="text_small_b g-80">
                    {t('return_delivery_cost')}: {returnInfoData?.total_delivery_cost ? formatLocalString(returnInfoData?.total_delivery_cost) : "0"}{t('price_txt')}
                </div>
              </div>
            </div>
          </li>
          <li className="info_item">
            <div className="label label_start">
              <span>{t('refund_amount2')}</span>
            </div>
            <div className="form_info payment_info">
              <div className="info_detail flex-8 column">
                <p className="price red">
                  {returnInfoData?.total_refund_price ? formatLocalString(returnInfoData?.total_refund_price) : "0"}
                  <i className="won xl">{t('price_txt')}</i>
                </p>
                <div className="text_small_b g-80 flex-4 column">
                  <div className="flex-center-4">
                    {t('point_refund2')}: {returnInfoData?.total_use_point_value ? formatLocalString(returnInfoData?.total_use_point_value) : "0"}{t('price_txt')}
                  </div>
                  <div className="flex-center-4">
                    {t('deposit_info_23')}: {returnInfoData?.total_use_balance_value ? formatLocalString(returnInfoData?.total_use_balance_value) : "0"}{t('price_txt')}
                  </div>
                  <div className="flex-center-4">
                    {t('payment_method_refund2')}: {returnInfoData?.settle_price ? formatLocalString(returnInfoData?.settle_price) : "0"}{t('price_txt')}
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>

      {/* 수거지 정보 */}
      {selectedReturnMethod === 'shop' && (
        <div className="my_container order_detail_form estimate_detail">
          <div className="order_title">
            <h3>{t('collection_info')}</h3> 
          </div>
          <ul className="default_info_table v2 addr_table">
            <li className="info_item">
              <div className="label label_start">
                <span>{t('select_delivery_address')}</span>
              </div>
              <div className="form_info">
                <div className="info_detail">
                  <div className="default_radio radio_list">
                    {deliveryLIst.map(item =>(
                      <div key={item.id}>
                        <input
                          type="radio"
                          name="selectDelivery"
                          id={item.id}
                          value={item.value}
                          checked={selectedDelivery === item.value}
                          onChange={handleDeliveryChange}
                          />
                        <label htmlFor={item.id}>{item.label}</label>
                      </div>
                    ))}

                    <button 
                      type="button" 
                      className="default_btn light_gray sm"
                      style={{marginLeft:'4px', maxWidth:'92px'}}
                      onClick={handleAddrSelectPopup}
                    >
                      {t('view_address_book')}
                    </button>
                  </div>
                </div>
              </div>
            </li>
            <li className="info_item addr_receiver">
              <div className="label label_start">
                <span>{t('name2')}</span>
              </div>
              <div className="form_info">
                <div className="info_detail">
                  <div className="default_input none_class">
                    <input
                      id="receiver"
                      type="text"
                      disabled={selectedDelivery === 'default'}
                      value={selectedDelivery === 'default' ? 
                        deliveryData.recipient_name || recipientInfo.name : 
                        recipientInfo.name}
                      onChange={(e) => {
                        if (selectedDelivery === 'new') {
                          setRecipientInfo(prev => ({
                            ...prev,
                            name: e.target.value
                          }));
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            </li>
            <li className="info_item addr_receiver">
              <div className="label label_start">
                <span>{t('phone_number')}</span>
              </div>
              <div className="form_info">
                <div className="info_detail">
                    <div className="default_input flex-center-8 none_class">
                      <input
                        type="text"
                        disabled={selectedDelivery === 'default'}
                        value={selectedDelivery === 'default' ? 
                          deliveryData.recipient_phone || recipientInfo.phone : 
                          recipientInfo.phone}
                        onChange={(e) => {
                          if (selectedDelivery === 'new') {
                            setRecipientInfo(prev => ({
                              ...prev,
                              phone: e.target.value
                            }));
                          }
                        }}
                      />
                    </div>
                  </div>
              </div>
            </li>
            <li className="info_item addr_edit">
              <div className="label label_start">
                <span>{t('address')}</span>
              </div>
              <div className="form_info">
                <div className="info_detail default_input">
                  <div className="address_input">
                    <div className="zip_code flex-center-4">
                      <input 
                        type="text" 
                        value={selectedDelivery === 'default' ? 
                          deliveryData.recipient_zipcode || deliveryAddress.zonecode : 
                          deliveryAddress.zonecode}
                        readOnly 
                      />
                      <button 
                        type="button" 
                        className="default_btn sm light_gray"
                        onClick={handlePostcodeOpen}
                        disabled={selectedDelivery === 'default'}
                      >
                        {t('postal_code_search')}
                      </button>
                    </div>
                    <input 
                      type="text" 
                      value={selectedDelivery === 'default' ? 
                        deliveryData.recipient_address_street || deliveryAddress.roadAddress : 
                        deliveryAddress.roadAddress}
                      readOnly 
                    />
                    <input 
                      type="text" 
                      placeholder={t('delivery_address_name9')} 
                      value={selectedDelivery === 'default' ? 
                        deliveryData.recipient_address_detail || deliveryAddress.detailAddress : 
                        deliveryAddress.detailAddress}
                      onChange={handleDetailAddressChange}
                      disabled={selectedDelivery === 'default'}
                    />
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      )}

      {/* 반품신청 동의 */}
      <div className="default_chk_box py-16">
        <input 
          id="requestAgree" 
          type="checkbox"
          checked={isAgreed}
          onChange={(e) => setIsAgreed(e.target.checked)}
        />
        <label htmlFor="requestAgree">
          <span>
            {t('return_application_history')}
            <Link 
              to="/return-policy" 
              className="color_g80 show_term"
            >
              {t('view')}
            </Link>
          </span>
        </label>
      </div>

      {/* 우편번호 모달 */}
      {isPostcodeOpen && (
        <>
          <div 
            className="dimmed" 
            onClick={handlePostcodeClose}
            style={{
              position: 'fixed',
              width: '100vw',
              height: '100vh',
              top: '0',
              left: '0',
              background: 'rgba(0, 0, 0, 0.50)',
              zIndex: 101
            }}
          />
          <div className="default_popup">
            <div className="modal_content">
              <div className="modal_wrap">
                <div className="modal_header">
                  <button 
                    type="button" 
                    className="close_btn" 
                    onClick={handlePostcodeClose}
                  ></button>
                </div>
                <div className="modal_body">
                  <DaumPostcodeEmbed
                    onComplete={handlePostcodeComplete}
                    onClose={handlePostcodeClose}
                    style={{ height: '460px' }}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* 주소록 선택 팝업 */}
      <AddressSelectPopup 
        isPopup={isPopupAddr} 
        setIsPopup={setPopupAddr} 
        deliveryData={deliveryData}
        onConfirm={handleAddressConfirm}
      />

      <PopupLoginError 
        isPopup={popupLoginError} 
        setIsPopup={setPopupLoginError}
        onConfirm={handleConfirm}
      />

      {/* 목록 버튼 */}
      <div className="submit_box bg">
        <button
          className="default_btn white lg"
          >{t('cancel')}
        </button>
        <button
          className="default_btn black lg"
          onClick={handleReturnSubmit}
          >{t('return_application2')}
        </button>
      </div>
    </div>
  )
};

export default OrderReturnForm;